"use client";
import { useState } from "react";
import Image from "next/image";
const products = {
  shirt: {
    label: "charcoal button-down shirt",
    original: "/examples/original/charcoal-shirt.webp",
    result: "/hero_images/hero_gallery/charcoal-shirt-hires.webp",
    width: 3584,
    height: 4800,
    position: "center top",
    unoptimized: true,
  },
  blouse: {
    label: "red checked wrap blouse",
    original: "/examples/original/red-wrap-blouse.webp",
    result: "/hero_images/hero_gallery/red-wrap-blouse-hires.webp",
    width: 3584,
    height: 4800,
    position: "center top",
    unoptimized: true,
  },
  dress: {
    label: "strawberry-print dress",
    original: "/examples/original/dress.png",
  },
  blazer: {
    label: "navy checked blazer",
    original: "/examples/original/blazer.webp",
  },
};
export default function ProductComparison({ initialProduct = "shirt" }) {
  const [product, setProduct] = useState(initialProduct);
  const [split, setSplit] = useState(31);
  const item = products[product];
  return (
    <div className="hero-visual">
      <div className="visual-top">
        <span>01 / From product to possibility</span>
        <span className="live-label">AI-generated result ↗</span>
      </div>
      <div className="compare" style={{ "--split": `${split}%` }}>
        <Image
          className="after"
          src={item.result || `/hero_images/hero_gallery/${product}.webp`}
          alt={`AI fashion model wearing the ${item.label}`}
          width={item.width || 1792}
          height={item.height || 2400}
          style={item.position ? { objectPosition: item.position } : undefined}
          priority
          unoptimized={item.unoptimized}
          sizes="(max-width: 800px) 100vw, 50vw"
        />
        <div className="before-wrap">
          <Image
            src={item.original}
            alt={`Original ${item.label} product photo`}
            fill
            unoptimized={item.unoptimized}
            sizes="(max-width: 800px) 100vw, 50vw"
          />
        </div>
        <span className="image-tag left">Product photo</span>
        <span className="image-tag right">On-model</span>
        <div className="divider">
          <span className="handle" aria-hidden="true">
            ‹ ›
          </span>
        </div>
        <input
          type="range"
          min="0"
          max="100"
          value={split}
          onChange={(event) => setSplit(Number(event.target.value))}
          aria-label="Compare original product photo and AI model result"
          aria-valuetext={`${split} percent original product photo`}
        />
      </div>
      <div className="visual-bottom">
        <span>↔ Drag to see the transformation</span>
        <div className="swatches" aria-label="Choose a product example">
          {Object.keys(products).map((name) => (
            <button
              key={name}
              onClick={() => setProduct(name)}
              aria-pressed={product === name}
            >
              {name[0].toUpperCase() + name.slice(1)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
